import { render, staticRenderFns } from "./classmanage.vue?vue&type=template&id=3d77c412&"
import script from "./classmanage.vue?vue&type=script&lang=js&"
export * from "./classmanage.vue?vue&type=script&lang=js&"
import style0 from "./classmanage.vue?vue&type=style&index=0&id=3d77c412&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports